/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReadCashUserSettingsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_user_settings_messages.pb'
import {ReadCashUserSettingsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_user_settings_messages.pb'


export const readUserSettings = (request:ReadCashUserSettingsRequest, options?: CashRequestOptions) => post<ReadCashUserSettingsRequest, ReadCashUserSettingsResponse>("/cash-app/goose-cash/v3/read-user-settings", request, {...options, rejectOnError: true })